import { updateStaticPage } from '../../../actions/siteadmin/updateStaticPage';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    if (values.content[0]?.content == null || values.content[0]?.content == '<p><br></p>' || values.content[0]?.content == '<p> </p>') {
        showToaster({ messageId: 'addCmsContent', toasterType: 'error' });
    } else {
        await dispatch(updateStaticPage(values));
    }
}

export default submit;